import {
  useEffect,
  useRef,
  useState,
  ChangeEvent,
  ComponentProps,
} from 'react';
import { useSearchBox, UseSearchBoxProps } from 'react-instantsearch-hooks-web';
import debounce from 'lodash.debounce';

import { ControlledSearchBox } from './controlledSearchBox';

export type SearchBoxProps = ComponentProps<'div'> & UseSearchBoxProps;

export function CustomSearchBox(props: any) {
  const { query, refine, isSearchStalled } = useSearchBox(props);
  const inputRef = useRef<HTMLInputElement>(null);
  const [inputValue, setInputValue] = useState(props?.searchQuery || '');

  function onReset() {
      setInputValue('');
      props?.setSearchQuery('');
  }
  const debouncedRefine = useRef(
    debounce((value: string) => {
      refine(value);
    }, 400)
  ).current;

  useEffect(() => {
    if (props?.searchQuery !== undefined) {
      setInputValue(props.searchQuery);
    }
  }, [props.searchQuery]);

  useEffect(() => {
    if (inputValue !== query) {
      debouncedRefine(inputValue);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inputValue, debouncedRefine]);

  // function onChange(event: ChangeEvent<HTMLInputElement>) {
  //   const { value } = event.currentTarget;
  //   setInputValue(value);
  //   if (props?.setSearchQuery) {
  //     props.setSearchQuery(value);
  //   }
  // }

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    const value = event.currentTarget.value;
    setInputValue(value);         // update internal state
    if (props?.onChange) {
      props.onChange(event);      // call parent callback
    }
  };

  return (
    <ControlledSearchBox
      className='relative border-b border-[#333]'
      inputRef={inputRef}
      isSearchStalled={isSearchStalled}
      onChange={handleChange}
      onReset={onReset}
      placeholder={props?.placeholder}
      value={inputValue}
      onFocus={props?.onFocus}
      onBlur={props?.onBlur}
      onSubmit={props?.onSubmit}
      onKeyDown={props?.onKeyDown}
    />
  );
}